import axios from '../../utils/axios';

type FreeMaterialRequestResponse = {
    data: { items: { token?: string } };
};

export const requestFreeMaterial = (materialId: number, email?: string): Promise<FreeMaterialRequestResponse> =>
    axios.get(`v1/order/free-material/request/${materialId}`, {
        params: email === undefined ? { directLink: true } : { directLink: true, email }
    }) as unknown as Promise<FreeMaterialRequestResponse>;
